export const REL_GUIDES = 'REL_GUIDES' // 获取指引按钮数据
